import { render, staticRenderFns } from "./MyMenu.vue?vue&type=template&id=2ba885e4&lang=html&"
import script from "./MyMenu.vue?vue&type=script&lang=js&"
export * from "./MyMenu.vue?vue&type=script&lang=js&"
import style0 from "./MyMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports